import React, { useState, createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [globalData, setGlobalDataData] = useState(null);

  const addData = (data) => {
    setGlobalDataData((prev) => ({ ...prev, ...data }));
  };

  const setCurrentTab = (tab) => {
    setGlobalDataData((prev) => ({ ...prev, tab }));
  };

  const contextObject = useMemo(() => ({ globalData, addData, setCurrentTab }), [globalData]);
  return <DataContext.Provider value={contextObject}>{children}</DataContext.Provider>;
}

DataProvider.propTypes = {
  children: PropTypes.object,
};

DataProvider.defaultProps = {
  children: {},
};

export const useGlobalData = () => useContext(DataContext);
